import React from 'react';
import FunctionsContext from './FunctionsContext'
import styled from 'styled-components';
import { Button, Stepper, Step, StepLabel, Divider } from '@material-ui/core';
import { Field, FieldArray, Form, Formik, FormikConsumer } from 'formik';
import { Checkbox } from 'formik-material-ui';


const SubContainer = styled.div`
    display:grid;
    height:72px;
    width:100%;
    background:#ffffff;
    grid-template-columns:10px auto 10px 350px 1fr;
    align-items:center;

`;


const Container = styled.div`
    width:100%;
`;



const TextContainer = styled.div`
    font-size:13px;
    color:#808080;
`;





const ButtonContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
`;

const ErrorInvalid = styled.div`
padding-left: 60px;
color: red;
`

class WorkflowFormAuthApproveOption extends React.Component {

    static contextType = FunctionsContext;
    render() {
        const { workflowSteps = [] } = this.context.functions.selectedFunctionDetails;

        return (
            <Container>
                <FormikConsumer>
                    {formikProps => (
                        <>
                            <SubContainer>
                                <div />
                                <Field
                                    color="primary"
                                    component={Checkbox}
                                    type="checkbox"
                                    name={this.props.name ? this.props.name : `shouldAutoApproveProcedures`}
                                    disableRipple
                                />
                                <div />
                                <TextContainer>
                                    Automatically approve all procedures the project intends to comply with as-is (excludes "NO" and "N/A").
                                </TextContainer>
                                <div />
                            </SubContainer>
                            {this.props.name == 'projectShouldAutoApproveProcedures' && formikProps.values['shouldAutoApproveProcedures'] == false && formikProps.values[this.props.name] == true && <ErrorInvalid>The function is not set to default to "Yes" for Comply As-is.  Please speak with the function manager.</ErrorInvalid>}

                            <Divider />
                        </>
                    )}
                </FormikConsumer>
            </Container>)
    }
}


export default WorkflowFormAuthApproveOption;